import { render, staticRenderFns } from "./updatevehicle.vue?vue&type=template&id=4610bafb&"
import script from "./updatevehicle.vue?vue&type=script&lang=js&"
export * from "./updatevehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports